module.exports = __webpack_public_path__ + "851ba2fb3942324ba3f40b165cbbdc15.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/1000_r_60.mp3
// module id = 437
// module chunks = 0